import { render, staticRenderFns } from "./largebox.vue?vue&type=template&id=43ddf721&scoped=true"
import script from "./largebox.vue?vue&type=script&lang=js"
export * from "./largebox.vue?vue&type=script&lang=js"
import style0 from "./largebox.vue?vue&type=style&index=0&id=43ddf721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ddf721",
  null
  
)

export default component.exports